import * as React               from 'react';

import { Typography           } from 'src/components/common/typography';

import { Wrapper,
         Container,
         DetailNoteVariants,
         detailnote_variants  } from 'src/components/features/qmmsg/detail/detail-note/ui';



type Props = {
  variant: DetailNoteVariants;
  header: string;
  note: string;
}
export const DetailNote: React.FC<Props> = ({
  variant,
  header,
  note,
}) => {
  const lookAndFeel = detailnote_variants.get(variant)!;

  return (
    <Wrapper lookAndFeel = { lookAndFeel }>
      <Container lookAndFeel = { lookAndFeel }>
        <Typography variant = { lookAndFeel.headerTypographyVariant }>{ header }</Typography>
        <Typography variant = { lookAndFeel.noteTypographyVariant }>{ note }</Typography>
      </Container>
    </Wrapper>
  );
};
